import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/charts";
import axios from "axios";
import Typography from "@mui/material/Typography";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Row, Col } from "antd";

const DemoColumn = () => {
  const [data, setData] = useState([]);
  const [selectedRange, setSelectedRange] = useState([new Date(), new Date()]);

  const apiUrl = process.env.REACT_APP_API_FilteredOTPCount;

  const toMidnightUTC = (date) => {
    const utcDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    return utcDate;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedRange.length !== 2) {
        return;
      }
      try {
        const startDate = toMidnightUTC(new Date(selectedRange[0]));
        const endDate = toMidnightUTC(new Date(selectedRange[1]));

        const response = await axios.post(apiUrl, {
          start_date: startDate.toISOString().split("T")[0],
          end_date: endDate.toISOString().split("T")[0],
        });

        const optCountWithFilter = response.data.otp_count_with_filter;
        // const optCountWithoutFilter = response.data.opt_count_without_filter;

        // Create a unified array that combines both datasets
        const combinedData = [];
        const currentDateFormatted = new Date(startDate);

        while (currentDateFormatted <= endDate) {
          const dateStr = currentDateFormatted.toISOString().split("T")[0];

          // Add data only for "With Filter" since the backend now returns only that
          combinedData.push({
            date: dateStr,
            value: optCountWithFilter[dateStr] || 0,
            category: "With Filter",
          });

          // Commenting out the old logic for "Without Filter"
          /*
          combinedData.push({
            date: dateStr,
            value: optCountWithoutFilter[dateStr] || 0,
            category: "Without Filter",
          });
          */

          currentDateFormatted.setDate(currentDateFormatted.getDate() + 1);
        }

        setData(combinedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedRange, apiUrl]);

  const handleDateChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectedRange([startDate, endDate]);
  };

  // Updated chart configuration
  const config = {
    data,
    // isGroup: true, // Commented out as we no longer have grouped data
    xField: "date",
    yField: "value",
    seriesField: "category", // Still keeping this for future use if needed
    xAxis: {
      label: {
        formatter: (val) => {
          const date = new Date(val);
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
      },
    },
    color: ({ category }) =>
      category === "With Filter" ? "#22CBCC" : "#2989FF", // Only one color will be used now

    legend: {
      position: "top-left",
    },
  };

  return (
    <div>
      <Typography variant="h6" component="div" style={{ marginBottom: "16px" }}>
        Total OTPs generated by the special testers Team
      </Typography>
      <Row>
        <Col xs={24} md={8} className="rdrDefinedRangesWrapper">
          <div className="statistics-container">
            <DateRangePicker
              onChange={handleDateChange}
              moveRangeOnFirstSelection={false}
              ranges={[
                {
                  startDate: selectedRange[0],
                  endDate: selectedRange[1],
                  key: "selection",
                },
              ]}
              className="custom-date-range-picker"
            />
          </div>
        </Col>

        <Col xs={24} md={{ span: 10, offset: 6 }}>
          <Column {...config} />
        </Col>
      </Row>
    </div>
  );
};

export default DemoColumn;
